module.exports = __webpack_public_path__ + "static/media/pacha.0a695b18.svg";